import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  selectCurrentToken,
  selectCurrentWhatsAppVoiceCallEnabled,
} from "../auth/authSlice";

import { RootState } from "../store";

export const NOTE_KEY_PREFIX = "note:";

export enum ViewingMode {
  Tasks = "Tasks",
  Notes = "Notes",
  CollectedData = "CollectedData",
}

export type State = {
  chatOpen: boolean;
  viewingMode: ViewingMode;
  feedbackDialogInfo: boolean;
  unsavedWorkKeys: string[];
};

const uxSlice = createSlice({
  name: "ux",
  initialState: {
    chatOpen: false,
    viewingMode: ViewingMode.Tasks,
    feedbackDialogInfo: false,
    unsavedWorkKeys: [] as string[],
  },
  reducers: {
    setChatOpenUxState: (state, action: PayloadAction<boolean>) => {
      state.chatOpen = action.payload;
    },
    setViewingMode: (state, action: PayloadAction<ViewingMode>) => {
      state.viewingMode = action.payload;
    },
    setFeedbackDialogInfo: (state, action: PayloadAction<boolean>) => {
      state.feedbackDialogInfo = action.payload;
    },
    setUnsavedWork: (
      state,
      action: PayloadAction<{ key: string; isDirty: boolean }>
    ) => {
      const { key, isDirty } = action.payload;
      state.unsavedWorkKeys = state.unsavedWorkKeys.filter((k) => k !== key);
      if (isDirty) {
        state.unsavedWorkKeys.push(key);
      }
    },
  },
});

export const {
  setChatOpenUxState,
  setViewingMode,
  setFeedbackDialogInfo,
  setUnsavedWork,
} = uxSlice.actions;

export default uxSlice.reducer;

export const selectChatOpenUxState = (state: RootState) => state.ux.chatOpen;
export const selectViewingMode = (state: RootState) => state.ux.viewingMode;
export const selectFeedbackDialogInfo = (state: RootState) =>
  state.ux.feedbackDialogInfo;
export const selectHasUnsavedWork = (state: RootState, keyPrefix = "") =>
  !!selectCurrentToken(state) &&
  selectCurrentWhatsAppVoiceCallEnabled(state) &&
  state.ux.unsavedWorkKeys.some((key) => key.startsWith(keyPrefix));
export const selectHasUnsavedNote = (state: RootState) =>
  selectHasUnsavedWork(state, NOTE_KEY_PREFIX);
